export const state = () => ({
  data: [],
  choices: undefined,
});

export const mutations = {
  SET_DATA(state, data) {
    state.data = data;
  },
  CLEAN(state) {
    state.data = [];
    state.choices = [];
  },
  SET_CHOICES(state, choices) {
    state.choices = choices;
  },
};

export const getters = {
  getQuery(state) {
    if (state.data.length) {
      return { presidents: state.data };
    }
    return {};
  },
};

export const actions = {
  setData({ commit }, data) {
    commit('SET_DATA', data);
  },
  setDataFromQuery({ commit }, { presidents }) {
    if (presidents) {
      let parsedData = presidents;

      if (!Array.isArray(presidents)) {
        parsedData = [presidents];
      }

      commit('SET_DATA', parsedData);
    } else {
      commit('SET_DATA', []);
    }
  },
  setChoices({ commit }, { presidents }) {
    commit('SET_CHOICES', presidents);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
